import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from 'containers/Full'
import Auth from 'containers/Auth'

// Views
import Profile from 'views/Profile'
import Help from 'views/Help'

// Orders
import Orders from 'views/Orders/List'
import OrderView from 'views/Orders/View'

// Techcenter
import TcView from 'views/Techcenter/View'
import TcEdit from 'views/Techcenter/Edit'
import TcList from 'views/Techcenter/List'

// Admins
import Admin from 'views/Admin/Index'
import Users from 'views/Admin/Users'
import Cities from 'views/Admin/Cities'
import Companies from 'views/Admin/Companies'
import VirtualNumbers from 'views/Admin/PBX/VirtualNumbers'
import InternalNumbers from 'views/Admin/PBX/InternalNumbers'
import IncomingCalls from 'views/Admin/PBX/IncomingCalls'
import Roles from 'views/Admin/Roles'

import CFList from 'views/Admin/CustomFields/CFList'
import CFEdit from 'views/Admin/CustomFields/CFEdit'

import StatusList from 'views/Admin/Statuses/StatusList'
import StatusEdit from 'views/Admin/Statuses/StatusEdit'

// Auth
import Login from 'views/Auth/Login'
import RemindPassword from 'views/Auth/RemindPassword'
import EmailLinkSend from 'views/Auth/EmailLinkSend'
import ResetPasswordEmail from 'views/Auth/ResetPasswordEmail'

import NotFoundComponent from 'views/404'

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/auth',
      name: 'Auth',
      component: Auth,
      redirect: '/auth/login',
      meta: {checkLogin: true},
      children: [
        {
          path: '/auth/login',
          name: 'Login',
          component: Login,
          meta: {label: 'Авторизация', checkLogin: true}
        },
        {
          path: '/auth/remind-password',
          name: 'RemindPassword',
          component: RemindPassword,
          meta: {checkLogin: true, title: 'Забыли пароль?'}
        },
        {
          path: '/auth/email-link-send',
          name: 'EmailLinkSend',
          component: EmailLinkSend,
          meta: {checkLogin: true, title: 'Ссылка отправлена'}
        },
        {
          path: '/auth/reset-password-email/',
          name: 'ResetPasswordEmail',
          component: ResetPasswordEmail,
          meta: {checkLogin: true, title: 'Ссылка отправлена'}
        }
      ]
    },
    {
      path: '/',
      redirect: '/orders',
      name: 'Home',
      component: Full,
      meta: {label: 'Аларм План'},
      children: [
        {
          path: 'orders',
          name: 'Orders',
          component: Orders,
          meta: {label: 'Заказы', requiresAuth: true},
          children: [
            {
              path: '/orders/:id',
              name: 'Order',
              component: OrderView,
              meta: {label: 'Информация о заказе', requiresAuth: true}
            },
            {
              path: '/orders/iframe/:id',
              name: 'OrderIframe',
              component: OrderView,
              meta: {label: 'Информация о заказе', requiresAuth: true, isIframe: true}
            }
          ]
        },
        {
          path: 'profile',
          name: 'Profile',
          component: Profile,
          meta: {label: 'Ваш профиль', requiresAuth: true}
        },
        {
          path: 'techcenters',
          name: 'Techcenters',
          component: TcList,
          meta: {label: 'Техцентры', requiresAuth: true},
          children: [
            {
              path: '/techcenters/card/:id',
              name: 'Techcenter',
              component: TcView,
              meta: {label: 'Информация о техцентре', requiresAuth: true},
              children: [
                {
                  path: '/techcenters/edit/:id',
                  name: 'TechcenterEdit',
                  component: TcEdit,
                  meta: {label: 'Изменить', requiresAuth: true}
                },
                {
                  path: '/techcenters/iframe/:id',
                  name: 'TechcenterIframe',
                  component: TcView,
                  meta: {label: 'Информация о техцентре', requiresAuth: true, isIframe: true}
                }
              ]
            },
            {
              path: '/techcenters/create',
              name: 'TechcenterCreate',
              component: TcEdit,
              meta: {label: 'Добавить техцентр', requiresAuth: true}
            }
          ]
        },
        {
          path: 'help',
          component: Help,
          meta: {label: 'Помощь', requiresAuth: true}
        },
        {
          path: 'help/*',
          name: 'Help',
          component: Help,
          meta: {label: 'Помощь', requiresAuth: true}
        },
        /**
         * Админка использует тот же общий контейнер,
         * поэтому является вложенным основого роута
         * При развитии проекта можно вынести в отдельный
         */
        {
          path: '/admin',
          name: 'Admin',
          component: Admin,
          meta: {label: 'Админ Центр', requiresAuth: true},
          children: [
            {
              path: '/admin/users',
              name: 'Users',
              component: Users,
              meta: {label: 'Пользователи', requiresAuth: true}
            },
            {
              path: '/admin/users/:id',
              name: 'ViewProfile',
              component: Profile,
              meta: {label: 'Профиль пользователя', requiresAuth: true}
            },
            {
              path: '/admin/cities',
              name: 'Cities',
              component: Cities,
              meta: {label: 'Города', requiresAuth: true}
            },
            {
              path: '/admin/companies',
              name: 'Companies',
              component: Companies,
              meta: {label: 'Компании', requiresAuth: true}
            },
            {
              path: '/admin/roles',
              name: 'Roles',
              component: Roles,
              meta: {label: 'Роли пользователей', requiresAuth: true}
            },
            {
              path: '/admin/pbx/virtual-numbers',
              name: 'VirtualNumbers',
              component: VirtualNumbers,
              meta: {label: 'Виртуальные номера', requiresAuth: true}
            },
            {
              path: '/admin/pbx/internal-numbers',
              name: 'InternalNumbers',
              component: InternalNumbers,
              meta: {label: 'Внутренние номера', requiresAuth: true}
            },
            {
              path: '/admin/pbx/incoming-calls',
              name: 'IncomingCalls',
              component: IncomingCalls,
              meta: {label: 'Статистика звонков', requiresAuth: true}
            },
            {
              path: 'custom-fields',
              name: 'CustomFields',
              component: CFList,
              meta: {label: 'Кастамные поля', requiresAuth: true},
              children: [
                {
                  path: '/custom-fields/edit/:id',
                  name: 'CustomFieldsEdit',
                  component: CFEdit,
                  meta: {label: 'Изменить кастомное поле', requiresAuth: true}
                },
                {
                  path: '/custom-fields/create',
                  name: 'CustomFieldsCreate',
                  component: CFEdit,
                  meta: {label: 'Добавить кастомное поле', requiresAuth: true}
                }
              ]
            },
            {
              path: 'statuses',
              name: 'Statuses',
              component: StatusList,
              meta: {label: 'Статусы', requiresAuth: true},
              children: [
                {
                  path: '/statuses/edit/:id',
                  name: 'StatusEdit',
                  component: StatusEdit,
                  meta: {label: 'Изменить статус', requiresAuth: true}
                },
                {
                  path: '/statuses/create',
                  name: 'StatusCreate',
                  component: StatusEdit,
                  meta: {label: 'Добавить статус', requiresAuth: true}
                }
              ]
            }
          ]
        }
      ]
    },
    {path: '*', component: NotFoundComponent}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js